export default {
  title: 'Portal de Pedidos',
  form: {
    username: {
      placeholder: 'Utilizador',
    },
    password: {
      placeholder: 'Palavra-passe',
    },
  },
  buttons: {
    submit: 'Entrar',
  },
  toasts: {
    auth_token_invalid: 'Token de autenticação inválido, por favor inicie sessão com as credenciais',
    credentials_invalid: 'Utilizador ou palavra-passe incorretos',
  },
};
